import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsPackagePaymentStatusVisible,
  selectPaymentDataByType,
} from '../../../../../../../selectors/paymentProcessing';
import { selectIsMobileLayout } from '../../../../../../../selectors/layout';
import { checkPaymentStatusThunk } from '../../../../../../../thunks/payment/checkPaymentStatus';
import { EPaymentType } from '../../../../../../../types/reducers/paymentProcessing';

export const usePackagePaymentStatus = () => {
  const isVisible = useSelector(selectIsPackagePaymentStatusVisible);
  const payment = useSelector(selectPaymentDataByType(EPaymentType.Package));
  const isMobile = useSelector(selectIsMobileLayout);

  const dispatch = useDispatch();

  const handleRetryClick = useCallback(() => {
    if (!payment) {
      return;
    }

    const { paymentId, provider } = payment;

    dispatch(checkPaymentStatusThunk({ type: EPaymentType.Package, paymentId, provider }));
  }, [dispatch, payment]);

  return { isVisible, isMobile, status: payment?.status, handleRetryClick };
};
